// 실제 RAG API 응답 본문 렌더 — 스트리밍 텍스트를 RichText로, 도착 전에는 스켈레톤
import React from 'react';
import RichText from '../../components/AI/RichText';
import type { ConvSlot } from './Home.types';
import styles from './Home.startview.module.css';

/* ── 실제 RAG API 응답 본문 (섹션 모드·대화 모드 공용) ── */
export function LiveResponseBody({ slot }: { slot: ConvSlot }) {
  return (
    <>
      {/* 진행 단계 문구는 응답 카드 헤더에 표시 — 본문은 텍스트 도착 전까지 스켈레톤만 */}
      {slot.liveText ? (
        <div className={styles.resultContent}>
          {/* div 래퍼 — 응답에 마크다운 표(<table>)가 포함될 수 있어 <p> 사용 불가.
              pre-wrap을 걸지 않는다 — 문단 간격은 RichText가 CSS로 정한다 */}
          <div className={styles.resultBody}>
            <RichText text={slot.liveText} />
          </div>
        </div>
      ) : slot.phase === 'streaming' ? (
        <div className={styles.skeletons}>
          <div className={styles.skelLine} style={{ width: '72%' }} />
          <div className={styles.skelLine} style={{ width: '58%' }} />
          <div className={styles.skelLine} style={{ width: '85%' }} />
        </div>
      ) : null}
    </>
  );
}
